/**
 * Sheet — overlay container: bottom sheet on phone, centered modal at
 * ≥900px (the responsive breakpoint decides — no `center` prop, unlike
 * the prototype, which toggled per-frame). Ported from
 * design/project/lib/dash2.jsx; pixel values live in the .ns-sheet-*
 * classes in index.css.
 *
 * Tap the scrim or the × to close; Escape closes too.
 */
import { useEffect, type ReactNode } from "react";
import { Icon, I } from "./Icons";

export interface SheetProps {
  title: ReactNode;
  onClose: () => void;
  children: ReactNode;
}

export function Sheet({ title, onClose, children }: SheetProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="ns-sheet-overlay" onClick={onClose}>
      <div
        className="ns-sheet-panel"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ns-sheet-grabber">
          <span />
        </div>
        <div className="ns-sheet-head">
          <h3>{title}</h3>
          <button
            type="button"
            className="ns-sheet-close"
            onClick={onClose}
            aria-label="Close"
          >
            <Icon d={I.x} size={15} />
          </button>
        </div>
        <div className="ns-sheet-body">{children}</div>
      </div>
    </div>
  );
}
